module.exports = __webpack_public_path__ + "static/1-0bd027831bfa3d7a136770ca53a2215d.jpg";